import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rms-toast',
  imports: [TranslateModule, MatIconModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  @Input() public icon = '';
  @Input() public color = 'black';
  @Input() public title = '';
  @Input() public message = '';
  @Input() public messageParams: Record<string, string> = {};
  @Input() public messageList: string[] = [];
  @Input() public canClose = false;

  @Output() public closed = new EventEmitter<void>();

  public textColor: Record<string, string> = {
    black: 'white',
    ruber: 'white',
    melleus: 'black',
    flavius: 'black',
    subdued: 'black',
    ochraceus: 'fulvus',
    caeruleus: 'cyaneus',
    violaceus: 'vinosus',
    viridis: 'atrovirens',
    fulvus: 'ochraceus',
    cyaneus: 'caeruleus',
    vinosus: 'violaceus',
    atrovirens: 'viridis',
  };
}
